import { Component, Input } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { AbstractListComponent } from '@reenstudio/app/shared/components/abstract-list/abstract-list.component';
import { PAYMENTS_LIST_MOCK } from '@reenstudio/app/core/mock/incentive/payments-mock';

@Component({
  selector: 'app-payments-page',
  templateUrl: './payments-page.component.html',
  styleUrls: ['./payments-page.component.scss'],
})
export class PaymentsPageComponent extends AbstractListComponent {
  @Input() override displayedColumns = ['date', 'type', 'amount', 'period'];

  override dataTable: MatTableDataSource<{}>;

  constructor() {
    super();
    this.dataTable = new MatTableDataSource<{}>([]);
  }

  protected override getList() {
    return (this.dataTable.data = PAYMENTS_LIST_MOCK);
  }
}
